<template>
  <div class="mod-hour-trading">
    <div class="hour-trading-price">
      <span>{{ hourTradingTag }}</span>
      <LatestPrice
        :stock="stock"
        :is-hour-trading="true"
        :show-change="false"
      />
    </div>
    <Metric :data="detail" />
    <Chart v-if="hourTradingData" :data="hourTradingData" :stock="stock" />
    <p class="hour-trading-warning">
      {{ $t('trade.hour-trading-warning') }}
    </p>
  </div>
</template>
<script>
import LatestPrice from 'mod/LatestPrice'
import Metric from './Metric'
import Chart from './Chart'
import { MARKET_OPEN_MAP, TIMER_EXPRESSION } from 'const/common'
import { TRADING_STATUS } from 'const/stock'
import { mapGetters } from 'vuex'
import { getHourTradingTrend } from 'apis/quote'

export default {
  name: 'HourTradingDetail',
  components: { Chart, Metric, LatestPrice },
  data() {
    return {
      hasData: true,
      hourTradingData: null
    }
  },
  props: {
    stock: Object
  },
  computed: {
    ...mapGetters(['usHourTrading', 'usTradingStatus']),
    symbol() {
      return this.stock.symbol
    },
    hourTradingTag() {
      return this.$t(MARKET_OPEN_MAP[this.stock.hourTradingTag])
    },
    detail() {
      return this.hourTradingData && this.hourTradingData.detail
    }
  },
  mounted() {
    this.loadData(true)
    this.usHourTrading && this.createTimer()
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    loadData() {
      const symbol = this.symbol
      return getHourTradingTrend({ symbol })
        .then(data => {
          if (this.symbol !== symbol) return
          this.hourTradingData = data
        })
        .catch(err => {
          if (err.ret === 30001) {
            this.hourTradingData = null
            this.clearTimer()
          }
        })
    },
    createTimer() {
      if (this.timer) {
        this.timer.resume()
      } else {
        this.timer = this.$cron(TIMER_EXPRESSION.HOUR_TRADING).interval(
          'hour-trading-refresh',
          this.loadData
        )
      }
    },
    clearTimer() {
      if (this.timer) {
        this.timer.clear()
        this.timer = null
      }
    }
  },
  watch: {
    symbol() {
      this.hourTradingData = null
      this.loadData(true)
    },
    usHourTrading(yes) {
      yes ? this.createTimer() : this.clearTimer()
    },
    usTradingStatus(status) {
      this.hourTradingData = null
      if (
        [
          TRADING_STATUS.UNOPENED,
          TRADING_STATUS.PRE_TRADING,
          TRADING_STATUS.POST_TRADING
        ].includes(status)
      ) {
        this.loadData()
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';
.mod-hour-trading {
  width: 100%;
  height: 260px;
  padding: 0 10px;
  margin: 10px 0;
}
.hour-trading-price {
  display: flex;
  align-items: baseline;
  height: 20px;
  line-height: 20px;
  margin-bottom: 6px;
  span {
    margin-right: 6px;
  }
}
.hour-trading-warning {
  height: 16px;
  line-height: 16px;
  color: @light-grey;
}
</style>
